import React from 'react';
import './logout-modal.sass';
import { Modal } from '../../../../components/modal/modal';
import { Button, ButtonSize, ButtonType } from '../../../../components/interface/button/button';
import { Config } from '../../../../config/config';
import { useSessionService } from '../../../../services/session/use-session.service';
import { useHistory } from 'react-router-dom';

export const LogoutModal = ({isVisible, setIsVisible}) => {
    const history = useHistory();
    const { logout } = useSessionService();

    const onLogoutClick = () => {
        logout();
        history.push(Config.routePaths.main.vendor.path);
    };

    return (
        <Modal isOpen={isVisible} setVisible={setIsVisible} title='Wyloguj się'  width={410} height={208}>
            <div className='vv-vendor-logout-modal'>
                <div className='vv-vendor-logout-modal__margin'>
                    <Button type='button' text='WYLOGUJ' size={ButtonSize.VENDOR} buttonType={ButtonType.BLACK} onClick={onLogoutClick}/>
                </div>
                <Button type='button' text='ANULUJ' size={ButtonSize.VENDOR} buttonType={ButtonType.TRANSPARENT_BORDER} onClick={() => setIsVisible(false)}/>
            </div>
        </Modal>
    );
};